<template>
  <label
    :class="borderColor"
    class="block relative h-12 border-b-2 pr-8 md:pr-10 md:h-16"
  >
    <span
      :class="labelColor"
      class="absolute flex left-0 top-0 text-xs leading-4 font-bold"
      >{{ label }}
      <IconDone class="h-4 w-4 ml-1" v-if="state === 'success'"/>
      <IconCross class="h-4 w-4 ml-1" v-if="state === 'error'"
    /></span>
    <span
      :class="
        state === 'disabled'
          ? 'text-AkGreyscaleMediumLtGrey'
          : 'text-AkGreyscaleBlack'
      "
      class="block pt-5 pr-auto pb-2 pl-2 w-full bg-transparent text-sm leading-5 font-normal md:pt-6 md:pb-4 md:leading-6"
      >{{ valueT.length > 0 ? valueT : 'Sélectionner' }}</span
    >
    <input
      v-show="false"
      class="hidden"
      type="checkbox"
      :checked="value"
      :disabled="state === 'disabled'"
      v-bind="$attrs"
      v-on="inputListeners"
    />
    <IconArrowheadDown
      v-if="!value"
      :class="
        state === 'disabled'
          ? 'text-AkGreyscaleMediumLtGrey'
          : 'text-AkGreyscaleBlack'
      "
      class="absolute select-none right-2 bottom-2 h-4 w-4 md:bottom-4 md:h-6 md:w-6"
    />
    <IconArrowheadTop
      v-else
      :class="
        state === 'disabled'
          ? 'text-AkGreyscaleMediumLtGrey'
          : 'text-AkGreyscaleBlack'
      "
      class="absolute select-none right-2 bottom-2 h-4 w-4 md:bottom-4 md:h-6 md:w-6"
    />
  </label>
</template>

<script>
import IconDone from './icons/IconDone.vue'
import IconCross from './icons/IconCross.vue'
import IconArrowheadDown from './icons/IconArrowheadDown.vue'
import IconArrowheadTop from './icons/IconArrowheadTop.vue'

export default {
  name: 'Dropdown',
  components: { IconDone, IconCross, IconArrowheadDown, IconArrowheadTop },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    value: {
      type: Boolean,
      default: false
    },
    valueT: {
      type: String,
      default: 'Sélectionner'
    },
    state: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    inputListeners: function () {
      return {
        ...this.$listeners,
        input: (event) => {
          this.$emit('input', event.target.checked)
        },
        // for Microsoft Edge
        change: (event) => {
          this.$emit('input', event.target.checked)
        }
      }
    },
    borderColor: function () {
      const { state } = this
      let color = 'border-Ak'

      switch (state) {
        case 'error':
          color += 'MajorCoral'
          break
        case 'success':
          color += 'MainGreen'
          break
        // case 'disabled':
        //   color += 'GreyscaleMediumLtGrey'
        //   break
        default:
          color += 'GreyscaleLtGrey'
          break
      }
      return color
    },
    labelColor: function () {
      const { state } = this
      let color = 'text-Ak'

      switch (state) {
        case 'error':
          color += 'MajorCoral'
          break
        case 'success':
          color += 'MainGreen'
          break
        case 'disabled':
          color += 'GreyscaleMediumLtGrey'
          break
        default:
          color += 'MajorTurquoise '
          break
      }
      return color
    }
  }
}
</script>
